import React from "react";

function SearchStats(props: {
  searching: boolean;
  found: number;
  more: boolean;
}) {
  const { searching, found, more } = props;
  return (
    <div className="btn-text">
      {(found > 0 && (
        <span>
          <strong>
            {found}
            {more && "+"}
          </strong>{" "}
          Products Found
        </span>
      )) ||
        (searching && <span>Searching products ...</span>) ||
        (found === 0 && (
          <span>No Matching Products Found. Try some different words ?</span>
        ))}
    </div>
  );
}

export default SearchStats;
